import basic from '../../../data/basic.json';
import renaissanceSet from '../../../data/details/01-new-renaissance.json';
import userGeneratedSet from '../../../data/details/02-user-generated.json';
import screenLifeSet from '../../../data/details/03-screen-life.json';
import typographySet from '../../../data/details/04-dynamic-typography.json';
import craftSet from '../../../data/details/05-craft.json';

// EN
import basicEn from '../../../data/en/basic.json';
import renaissanceSetEn from '../../../data/en/details/01-new-renaissance.json';
import userGeneratedSetEn from '../../../data/en/details/02-user-generated.json';
import screenLifeSetEn from '../../../data/en/details/03-screen-life.json';
import typographySetEn from '../../../data/en/details/04-dynamic-typography.json';
import craftSetEn from '../../../data/en/details/05-craft.json';

let lang = 'ru';

if (document) lang = document.documentElement.getAttribute('lang');

export default (lang === 'en'
    ? {
        basic: basicEn,
        renaissanceSet: renaissanceSetEn,
        userGeneratedSet: userGeneratedSetEn,
        screenLifeSet: screenLifeSetEn,
        typographySet: typographySetEn,
        craftSet: craftSetEn
    }
    : {
        basic,
        renaissanceSet,
        userGeneratedSet,
        screenLifeSet,
        typographySet,
        craftSet
    });
